export default __webpack_public_path__ + "static/media/ComputerTeacher.9613029e.jpg";